import { Component, OnInit } from '@angular/core';
import { TRANSACTION_TAB_OPTIONS } from 'src/app/lib/constants/tabs.constants';

@Component({
  selector: 'app-promo',
  templateUrl: './promo.component.html',
  styleUrls: ['./promo.component.scss']
})

export class PromoComponent {
  tabs = TRANSACTION_TAB_OPTIONS;

  constructor() { }



}
